<template>
<div>
    <b-row>
        <b-col md="6" class="my-1">
            <h3 class="text-themecolor">{{$t('priceagreements.prijsafspraken')}}</h3>
        </b-col>
        <b-col md="6" class="my-1">
            <div class="pull-right">
                <b-button v-b-modal.modalPriceAgreements variant="themecolor" size="sm" @click.stop="loadModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> {{$t('buttons.toevoegen')}}</b-button>
            </div>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <div class="card">
                <div class="card-body">
                    <!-- User Interface controls -->
                    <b-row>
                        <b-col md="12" class="my-1">
                            <b-form-group class="mb-0">
                                <b-input-group>
                                    <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- User Interface controls -->

                    <!-- Main table element -->
                    <b-row>
                        <b-col md="12">
                            <b-table class="table-hover"
                                     show-empty 
                                     :items="priceAgreements"  
                                     :empty-text="getEmptyText(count)" 
                                     :fields="fields" 
                                     :current-page="currentPage" 
                                     :per-page="perPage" 
                                     :filter="filter" 
                                     @filtered="onFiltered"
                                     :busy="count == -1">
                                <template v-slot:cell(priceAgreementType)="data">{{ data.item.priceAgreementType | agreementType }}</template>
                                <template v-slot:cell(price)="data">{{ data.item.price | currency }}</template>
                                <template v-slot:cell(isVariable)="data">{{ data.item.isVariable ? $t('priceagreements.variabel') : $t('priceagreements.vast') }}</template>
                                <template v-slot:cell(invoiceType)="data">{{ data.item.invoiceType | invoiceType }}</template>
                                <template v-slot:cell(cycleInMonths)="data">{{ data.item.cycleInMonths | cycle }}</template>
                                <template v-slot:cell(actions)="row">
                                    <b-button v-b-modal.modalPriceAgreements variant="themecolor" size="sm" @click.stop="loadModal(row.item)">
                                        <i class="fa fa-edit" aria-hidden="true"></i>
                                    </b-button>
                                    <delete title="Prijsafspraak" 
                                        :noRedirect="true" 
                                        :hideText="true" 
                                        :id="row.item.id" 
                                        namespace="fm" 
                                        resource="price-agreements" />
                                </template>
                                <template v-slot:table-busy>
                                    <PreLoader/>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <!-- Main table element -->

                    <!-- Pagination controls -->
                    <b-row>
                        <b-col md="12" lg="5">
                            <b-form-group label-cols :label="$t('datatables.perpagina')">
                                <b-form-select :options="pageOptions" v-model="perPage" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" lg="7">
                            <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                        </b-col>
                    </b-row>
                    <!-- Pagination controls -->
                </div>
            </div>
        </b-col>
    </b-row>
    <!-- Modal Component -->
    <b-modal id="modalPriceAgreements" ref="priceagreements" :title="`${$t('priceagreements.prijsafspraak')} ${command.id ? $t('klantrelaties.bewerker') : $t('klantrelaties.aanmaker')}`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
        <b-form @submit="onSubmit" autocomplete="off">
            <!-- Form content -->
            <b-form-group label-cols :label="$t('datatables.naam')" label-for="name">
                <b-form-input id="name" v-model="command.name" type="text" :placeholder="$t('datatables.naam')" />
                <validation element="name" />
            </b-form-group>
            <b-form-group label-cols :label="$t('datatables.type')" label-for="price_agreement_type">
                <b-form-select id="price_agreement_type" v-if="priceAgreementsTypes" v-model="command.priceAgreementType">
                    <option value="0">{{$t('priceagreements.selecteereentype')}}</option>
                    <option :key="index" :value="priceAgreementType.id" v-for="(priceAgreementType, index) in priceAgreementsTypes">{{ priceAgreementType.name }}</option>
                </b-form-select>
                <validation element="price_agreement_type" />
            </b-form-group>
            <b-form-group label-cols :label="$t('datatables.tarief')" label-for="agreement_price">
                <vue-numeric currency="€" separator="." :precision="2" :value="command.price / 100"  @input="value => command.price = value * 100" class="form-control" id="agreement_price" />         
                <validation element="agreement_price" />
            </b-form-group>
            <b-form-group label-cols :label="$t('datatables.kostensoort')" label-for="costs">
                <b-form-radio-group id="costs" class="modal-radio" v-model="isVariable" :options="options" @change="clearInvoiceType()" buttons button-variant="secondary">
                </b-form-radio-group>
                <validation element="costs" />
            </b-form-group>
            <b-form-group label-cols :label="$t('datatables.facturatietype')" label-for="invoice_type" v-if="isVariable">
                <b-form-radio-group id="invoice_type" class="modal-radio" v-model="invoiceType" :options="optionsVariable" buttons button-variant="secondary">
                </b-form-radio-group>
                <validation element="invoice_type" />
            </b-form-group>
            <b-form-group label-cols :label="$t('datatables.facturatiecyclus')" label-for="cycle_in_months">
                <b-form-radio-group id="cycle_in_months" class="modal-radio" v-model="command.cycleInMonths" :options="cycle" buttons button-variant="secondary">
                </b-form-radio-group>
                <validation element="cycle_in_months" />
            </b-form-group>
            <!-- Form content -->
            <hr />
            <!-- Submit controls -->
            <b-row>
                <b-col md="12">
                    <b-button @click="$refs.priceagreements.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                    <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                </b-col>
            </b-row>
            <!-- Submit controls -->
        </b-form>
    </b-modal>
    <!-- Modal Component -->
</div>
</template>

<script>
//Import store
import {
    mapGetters,
    mapActions
} from 'vuex'

//Import command
import Command from './command'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
    name: `price-agreements-index`,
    components: {PreLoader},
    data() {
        return {
            command: {},
            isVariable: false,
            invoiceType: 0,
            currentPage: 1,
            perPage: 50,
            pageOptions: [50, 100, 200],
            filter: null,
            count: -1
        }
    },
    computed: {
        options() { 
            return [
                {
                    text: this.$i18n.t('priceagreements.vast'),
                    value: false
                },
                {
                    text: this.$i18n.t('priceagreements.variabel'),
                    value: true
                }
            ]
        },
        optionsVariable() { 
            return[
                {
                    text: this.$i18n.t('priceagreements.document'),
                    value: 2
                },
                {
                    text: this.$i18n.t('priceagreements.factuur'),
                    value: 3
                },
                {
                    text: this.$i18n.t('priceagreements.bijlage'),
                    value: 1
                },
            ]
        },
        cycle() {
            return [
                {
                    text: this.$i18n.t('priceagreements.maand'),
                    value: 1
                },
                {
                    text: this.$i18n.t('priceagreements.kwartaal'),
                    value: 3
                },
                {
                    text: this.$i18n.t('priceagreements.jaar'),
                    value: 12
                }
            ]
        },
        fields() { 
            return [{
                    key: 'name',
                    label: this.$i18n.t('datatables.naam'),
                    sortable: true
                },
                {
                    key: 'priceAgreementType',
                    label: this.$i18n.t('datatables.type'),
                    sortable: true
                },
                {
                    key: 'price',
                    label: this.$i18n.t('datatables.tarief'),
                    sortable: true
                },
                {
                    key: 'isVariable',
                    label: this.$i18n.t('datatables.kostensoort'),
                    sortable: true,
                },
                {
                    key: 'invoiceType',
                    label: this.$i18n.t('datatables.facturatietype'),
                    sortable: true,
                },
                {
                    key: 'cycleInMonths',
                    label: this.$i18n.t('datatables.cyclus'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$i18n.t('datatables.acties')
                }
            ]
        },
        ...mapGetters ('fm', ['priceAgreements','priceAgreementsTypes']),
    },
    methods: {
        ...mapActions('fm', ['all', 'create', 'update', 'delete']),
        onFiltered(filteredItems) {
            this.count = filteredItems.length;
            this.currentPage = 1
        },
        loadModal(item) {
            let vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.command = new Command(item);
            this.isVariable = vm.command.isVariable
            this.invoiceType = vm.command.invoiceType
        },
        clearInvoiceType() {
            this.invoiceType = 0
        },
        onSubmit(event) {
            event.preventDefault();
            let vm = this;
            vm.command.agreementPrice = vm.command.price
            vm.command.isVariable = this.isVariable
            vm.command.invoiceType = this.invoiceType

            let payload = {
                resource: 'price-agreements',
                path: vm.$route.path,
                params: vm.command
            };

            let action = vm.command.id ? vm.update(payload) : vm.create(payload);
            action.then(() => {
                vm.$refs.priceagreements.hide();
            })
        },
        getEmptyText,
    },
    created() {
        let vm = this;
        vm.all({
            resource: 'price-agreements'
        })
        .then((data) => {
            vm.count = data.result.length;
        });
    },
    mounted() {
        let vm = this;
        vm.command = new Command();
    }
}
</script>
